import { replace } from '@/services/useful';


    /*
    * https://ganlanyuan.github.io/tiny-slider/demo/
    */

    export function carousel()
    {

        document.querySelectorAll(`.__CAROUSEL__`).forEach($item => {
            if(!$item.classList.contains(`__CAROUSEL__OK`)){
                $item.classList.add(`__CAROUSEL__OK`);

                // CARROCEL MOBILE
                    if($item.classList.contains("__CAROUSEL_MOBILE__")){
                        item.classList.add(`dn_1000`);
                        item.insertAdjacentHTML('afterend', `<div class="__CAROUSEL_MOBILE__ dnn_1000">${$item.innerHTML}</div>`)
                    }
                // CARROCEL MOBILE

                let $items = $item.getAttribute(`items`) ? $item.getAttribute(`items`) : 5;
                let $banner = $item.getAttribute(`items`)==1 ? true : false;
                let $no_loop = $item.getAttribute(`no_loop`)==1 ? false : true;
                let $auto = $item.getAttribute(`auto`)==0 ? false : true;
                let $auto_time = $item.getAttribute(`auto`)==0 ? false : $item.getAttribute(`auto`)*1000;
                let $flexible_height = $item.getAttribute(`flexible_height`)==0 ? false : true;

                let $obj = {
                    container: $item,
                    nav: true,
                    items: parseInt($items),
                    loop: $no_loop,
                    mouseDrag: true, // Arrastar o mouse
                    speed: 1000,
                    //lazyload: true, // carga preguicosa (se ativar desativa autoHeight)

                    autoplay: $auto,
                    autoplayTimeout: $auto_time,
                    //autoplayHoverPause: true,
                    //autoplayText: ["▶", "❚❚"],
                    //autoplayButtonOutput: false, // Botão de reprodução automática Saída

                    //fixedWidth: 400, // tamanho fixo
                    //autoWidth: true, // autoWidth
                    autoHeight: true, swipeAngle: false, // autoHeight

                    //startIndex: 6, // índice inicial
                    //arrowKeys: true, // mexer com o telhado
                    //controlsContainer: "#customize-controls", //personalizar controles

                    //mode: "gallery",
                    //animateIn: "jello",
                    //animateOut: "rollOut",

                    //navContainer: "#customize-thumbnails", // carrocel thumbs
                    //navAsThumbnails: true,
                    //autoplayTimeout 1000,
                    //autoplayButton: "#customize-toggle",

                }

                // PARA BANNER
                    if($banner){
                        $obj.slideBy = `page`;
                    }
                // PARA BANNER

                // RESPONSIVE
                    let $responsive = new Object();

                    let $big = 1000;
                    //let $last = parseInt($items);
                    for(const $name of $item.getAttributeNames()){
                        if(!$name.indexOf(`resp_`)){
                            let $resp = replace(`resp_`, ``, $name);
                            $responsive[$resp] = { items: parseInt($item.getAttribute($name)) };
                            //$last = $item.getAttribute($name);
                            $big = $big < parseInt($resp) ? parseInt($resp) : $big;
                        }
                    }
                    //$responsive[0] = { items: $last };

                    $responsive[$big+1] = { items: parseInt($items) };

                    $obj.responsive = $responsive;
                // RESPONSIVE


                // CHAMANDO CARROCEL LIBRARY
                    let $class_init = $item.getAttribute(`class`);

                    let $tns_ = tns($obj);

                    if($item.classList.contains(`_TNS_`)){
                        $_GLOBAL.$TNS = $tns_;
                    }
                // CHAMANDO CARROCEL LIBRARY

                // ADD CLASS NO PARENT PARA CSS (SETA E PAGG)
                    $class_init = replace(`__CAROUSEL_MOBILE__`, ``, $class_init);
                    $class_init = replace(`__CAROUSEL__OK`, ``, $class_init);
                    $class_init = replace(`__CAROUSEL__`, ``, $class_init);
                    let $array = $class_init.split(` `);
                    $array.map(function($value, $key){
                        if($value){
                            try {
                                if($item.parentNode.classList.contains(`tns-outer`)){
                                    $item.parentNode.classList.add($value);

                                } else if($item.parentNode.parentNode.classList.contains(`tns-outer`)){
                                    $item.parentNode.parentNode.classList.add($value);

                                } else if($item.parentNode.parentNode.parentNode.classList.contains(`tns-outer`)){
                                    $item.parentNode.parentNode.parentNode.classList.add($value);

                                } else if($item.parentNode.parentNode.parentNode.parentNode.classList.contains(`tns-outer`)){
                                    $item.parentNode.parentNode.parentNode.parentNode.classList.add($value);
                                }
                            } catch(e) { }
                        }
                    })
                // ADD CLASS NO PARENT PARA CSS (SETA E PAGG)
            }
        });


    }    

